module.exports = __webpack_public_path__ + "img/icon-company.ab532543.png";